import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useState } from "react";

function MyCalendar() {
  const [date, setDate] = useState(new Date());

  return (
    <div className="card p-3">
      <h5>Calendar</h5>

      <Calendar 
        onChange={setDate} 
        value={date} 
      />

      <p className="mt-2">
        {date.toDateString()}
      </p>
    </div>
  );
}

export default MyCalendar;